<div fxLayout="row" fxLayoutAlign="space-between" class="ocl-control-container">
  <div class="dx-field">
    <div class="dx-field-label">
      Status
    </div>
    <div class="dx-field-value">
      <dx-drop-down-box [dataSource]="statuses" placeholder="Select a value..." [value]="control?.value">
        <div *dxTemplate="let data of 'content'">
          <dx-data-grid
            [dataSource]="statuses"
            [selection]="{ mode: 'multiple' }"
            [hoverStateEnabled]="true"
            [scrolling]="{ mode: 'virtual' }"
            [selectedRowKeys]="control?.value"
            (selectedRowKeysChange)="selectionChange($event)"
          >
            <dxi-column caption="Status" cellTemplate="statusCellTemplate"></dxi-column>

            <div *dxTemplate="let status of 'statusCellTemplate'">
              {{status.data}}
            </div>
          </dx-data-grid>
        </div>
      </dx-drop-down-box>
    </div>
  </div>
</div>
